import(/* webpackMode: "eager" */ "/private/tmp/mosquarium-nextjs-deploy/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppErrorBoundary"] */ "/private/tmp/mosquarium-nextjs-deploy/components/AppErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlbModelsFromRoute"] */ "/private/tmp/mosquarium-nextjs-deploy/components/GlbModelsFromRoute.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalAudioFeedback"] */ "/private/tmp/mosquarium-nextjs-deploy/components/GlobalAudioFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandscapeBlocker"] */ "/private/tmp/mosquarium-nextjs-deploy/components/LandscapeBlocker.tsx");
;
import(/* webpackMode: "eager" */ "/private/tmp/mosquarium-nextjs-deploy/node_modules/animate.css/animate.css");
;
import(/* webpackMode: "eager" */ "/private/tmp/mosquarium-nextjs-deploy/node_modules/next/dist/client/script.js");
